import React, { useEffect, useState } from 'react';
import { CommentOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';
import IntlMessage from 'components/util-components/IntlMessage';
import AuthButton from 'auth/gard/AuthButton';
import Utils from 'utils';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
const SupportButton = () => {
    const history = useHistory();
    const location = useLocation();
    const [show, setShow] = useState(true);
    const isMobile = !Utils.getBreakPoint(useBreakpoint()).includes('lg')


    useEffect(() => {
        if (location.pathname.includes('/app/supports/list/compose')) {
            setShow(false);
        } else {
            setShow(true);
        }
    }, [location.pathname, isMobile]);

    if (!show) {
        return null;
    }

    return (
        <div style={{ position: 'fixed', right: 0, bottom: 0, paddingRight: 20, paddingBottom: 20 }}>
            {isMobile ? (
                <AuthButton
                    type="primary"
                    shape="round"
                    icon={<CommentOutlined />}
                    size="large"
                    noAdmin
                    onClick={() => history.push('/app/supports/list/compose')}
                    auth={['ROLE_CREATE_SUPPORT', 'ROLE_SHOP']}
                    block
                />) :
                (<AuthButton
                    type="primary"
                    shape="round"
                    icon={<CommentOutlined />}
                    size="large"
                    noAdmin
                    onClick={() => history.push('/app/supports/list/compose')}
                    auth={['ROLE_CREATE_SUPPORT', 'ROLE_SHOP']}
                    block
                >
                    <span><IntlMessage id="support.create_ticket" /></span>
                </AuthButton>)
            }
        </div>
    );
}

export default SupportButton;